import React from "react";

import InsightList from "components/Insights/InsightList";
const Insights = () => {
  return (
      <InsightList></InsightList>
  )
};

export default Insights;